import React from 'react';
import { makeStyles } from 'tss-react/mui';
import EventPassportRequiredInfo from './EventPassportRequiredInfo';

interface IProps {
  bgColor?: string;
  mt?: number;
  mlr?: number;
}

const useStyles = makeStyles<IProps>()((theme: any, params) => ({
  requiredPassportInfoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    ...(params?.mlr && { marginLeft: params.mlr, marginRight: params?.mlr }),
    marginTop: typeof params?.mt === 'number' ? params?.mt : 8,
    padding: '10px 32px 10px 23px',
    backgroundColor: params?.bgColor || theme.palette.primary.extraLight,
    borderRadius: 8,
    '@media (max-width: 1187px)': {},
    '@media (max-width: 600px)': {},
  },
}));

const EventPassportRequiredInfoContainer: React.FC<React.PropsWithChildren<IProps>> = ({ bgColor, mt, mlr }) => {
  const { classes } = useStyles({ bgColor, mt, mlr });
  return (
    <div id="passport-required-info" className={classes.requiredPassportInfoContainer}>
      <EventPassportRequiredInfo />
    </div>
  );
};

export default EventPassportRequiredInfoContainer;
